import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/features/home/home-page";

/**
 * Home: the landing page of a login without a dashboard (`landingTarget` in nav.ts). Signing in is
 * all it asks: it shows nothing a role could be refused, only a welcome and a pointer to the menu.
 */
export const Route = createFileRoute("/_app/home")({
  component: HomePage,
});
